import React, { useEffect, useState } from "react";
import { AiOutlineRight, AiOutlineFileText } from "react-icons/ai";
import moment from "moment";

const InvoiceListItem = ({data, type, onSelect}:any) => {

    const formatName = (name:any) =>{
        let clean = (name).slice(12).replaceAll('.pdf','').replaceAll('_',' ').split(' ');
        for (var i = 0; i < clean.length; i++) {
            clean[i] = clean[i].charAt(0).toUpperCase() + clean[i].substring(1);     
        }
        return clean?.join(' ');
    }
    
    return (
        <div className="invoice-list-item">
            <div className="left">
            {type===2?(
                <p className="name">{data?formatName(data):""}</p>
            ):(
                <>
                    <p className="name">{data?.product ?? data?.billTitle ?? '-'}</p>
                    <p className="order-num">{data?.nominationNo?? data?.billAccount ?? '-'}</p>
                </>
            )}
            </div>
            <div className="right">
                <div className="right-data">
                    {type===2?(
                        <p className="value"><AiOutlineFileText/> Preview</p>
                    ):(
                        <>
                        {type===0?(
                            <p className="value">${(data?.amount!==null||data?.amount!==undefined) ? (data?.amount)?.toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'USD',
                            }):'-'}</p>
                        ):(
                            <p className="value">${(data?.billAmount!==null||data?.billAmount!==undefined) ? (data?.billAmount)?.toLocaleString('en-US', {
                                style: 'currency',
                                currency: 'USD',
                                }):'-'}</p>
                        )}
                        {type===0?(
                            <p className="due">Issued: {data?.issuedDate ? moment(data?.issuedDate).format('MMM DD, YYYY'):'-'}</p>
                        ):(
                            <p className="due">{type===1?"Billing Period":"Date"}: {data?.billPeriod ? data?.billPeriod : moment(data?.issuedDate).format('MMM DD, YYYY')}</p>
                        )}
                        </>
                    )}
                </div>
                <AiOutlineRight className="arrow" onClick={()=>onSelect([data,type])}/>
                {/* {type===0 && (<AiOutlineRight className="arrow" onClick={()=>onSelect(data)}/>)} */}
            </div>
        </div>
    )
}

export default InvoiceListItem;